// extracted by mini-css-extract-plugin
export default {"circle":"EmailCircle_circle__VkbIt","circle__logo":"EmailCircle_circle__logo__tSuqY"};